(function(){
  'use strict';

  document.addEventListener('DOMContentLoaded', function(){
    var cartDrawer = document.querySelector('cart-drawer');
    if(cartDrawer){
      var newCartDrawer = cartDrawer.cloneNode(true);
      cartDrawer.parentNode.replaceChild(newCartDrawer, cartDrawer);
    }
    var cartNotif = document.querySelector('cart-notification');
    if(cartNotif){
      var newNotif = cartNotif.cloneNode(true);
      cartNotif.parentNode.replaceChild(newNotif, cartNotif);
    }
  });

  if(window.__csCartDrawerInitialized) return;
  window.__csCartDrawerInitialized = true;

  var __lastAddTime = 0;
  var __lastAddPromise = null;
  var origFetch = window.fetch.bind(window);
  window.fetch = function(url, opts){
    if(typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && (opts.method === 'POST' || opts.method === 'post')){
      var now = Date.now();
      if(now - __lastAddTime < 1500 && __lastAddPromise){
        return __lastAddPromise;
      }
      __lastAddTime = now;
      __lastAddPromise = origFetch(url, opts);
      return __lastAddPromise;
    }
    return origFetch(url, opts);
  };

  function disableDawnProductForm(){
    try {
      var ProductForm = customElements.get('product-form');
      if(ProductForm && ProductForm.prototype && ProductForm.prototype.onSubmitHandler){
        ProductForm.prototype.onSubmitHandler = function(evt){
          if(evt && evt.preventDefault) evt.preventDefault();
          if(evt && evt.stopPropagation) evt.stopPropagation();
          if(evt && evt.stopImmediatePropagation) evt.stopImmediatePropagation();
          return false;
        };
      }
    } catch(e){}
  }
  disableDawnProductForm();
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', disableDawnProductForm);
  }
  window.addEventListener('load', disableDawnProductForm);

  document.body.classList.remove('cs-drawer-open');

  var INITIAL_PRODUCTS = 30;
  var PRODUCTS_PER_LOAD = 30;
  var TOTAL_PRODUCTS_LIMIT = 250;
  var bestSellersLoaded = false;
  var bestSellersLoading = false;
  var allProducts = [];
  var productsShown = 0;
  var currentCart = null;

  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return (c||document).querySelectorAll(s);}

  function moneyFormat(cents){
    var n = cents/100;
    return '$' + n.toLocaleString('es-CO',{minimumFractionDigits:0,maximumFractionDigits:0}).replace(/,/g,'.');
  }

  function extractSizes(title){
    if(!title) return {euro: null, col: null};
    var t = title.toUpperCase();
    var euroMatch = t.match(/(\d+)\s*EURO/);
    var colMatch = t.match(/(\d+)\s*COL/);
    return {
      euro: euroMatch ? parseInt(euroMatch[1]) : null,
      col: colMatch ? parseInt(colMatch[1]) : null
    };
  }

  function classifyByGender(euroNum){
    if(euroNum === null) return 'OTRO';
    if(euroNum <= 39) return 'DAMA';
    if(euroNum >= 40) return 'HOMBRE';
    return 'OTRO';
  }

  function buildSizePills(variants){
    var groups = {DAMA: [], HOMBRE: [], OTRO: []};
    for(var i=0;i<variants.length;i++){
      var v = variants[i];
      var sizes = extractSizes(v.title);
      var gender = classifyByGender(sizes.euro);
      var displayNum = sizes.col || sizes.euro;
      var pill = {
        num: displayNum,
        label: displayNum ? (displayNum + ' CO') : v.title,
        variantId: v.id,
        available: v.available,
        title: v.title
      };
      groups[gender].push(pill);
    }
    function sortByNum(a,b){
      if(a.num === null && b.num === null) return 0;
      if(a.num === null) return 1;
      if(b.num === null) return -1;
      return a.num - b.num;
    }
    groups.DAMA.sort(sortByNum);
    groups.HOMBRE.sort(sortByNum);
    groups.OTRO.sort(sortByNum);
    return groups;
  }

  function renderSizesForProduct(variants){
    var groups = buildSizePills(variants);
    var hasGenderSplit = groups.DAMA.length > 0 && groups.HOMBRE.length > 0;
    var html = '';

    function renderPills(arr){
      var h = '<div class="cs-pc-sizes-grid">';
      for(var i=0;i<arr.length;i++){
        var pill = arr[i];
        var outClass = !pill.available ? 'out' : '';
        h += '<div class="cs-pc-sb '+outClass+'" data-vid="'+pill.variantId+'" data-title="'+pill.title.replace(/"/g,'&quot;')+'" data-label="'+pill.label+'">'+pill.label+'</div>';
      }
      h += '</div>';
      return h;
    }

    if(hasGenderSplit){
      html += '<div class="cs-pc-glabel">DAMA</div>';
      html += renderPills(groups.DAMA);
      html += '<div class="cs-pc-glabel">HOMBRE</div>';
      html += renderPills(groups.HOMBRE);
      if(groups.OTRO.length > 0){
        html += '<div class="cs-pc-glabel">OTRAS</div>';
        html += renderPills(groups.OTRO);
      }
    } else {
      var all = groups.DAMA.concat(groups.HOMBRE).concat(groups.OTRO);
      html += renderPills(all);
    }

    return html;
  }

  function syncHeaderCartIcon(){
    return origFetch('/?sections=cart-icon-bubble', {cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(data){
        var sectionHTML = data['cart-icon-bubble'];
        if(!sectionHTML) return;
        var icon = document.querySelector('#cart-icon-bubble');
        if(!icon) return;
        var temp = document.createElement('div');
        temp.innerHTML = sectionHTML;
        var newSection = temp.querySelector('#shopify-section-cart-icon-bubble');
        if(newSection){
          icon.innerHTML = newSection.innerHTML;
        } else {
          icon.innerHTML = sectionHTML;
        }
      })
      .catch(function(e){});
  }

  function updateHeaderBubbleLocal(count){
    var bubble = document.querySelector('.cart-count-bubble');
    if(!bubble) return;
    var span = bubble.querySelector('span[aria-hidden="true"]');
    if(span) span.textContent = count;
  }

  function openDrawer(){
    var d = $('#cs-cart-drawer');
    var o = $('#cs-cart-drawer-overlay');
    if(!d || !o) return;
    d.classList.add('open');
    o.classList.add('open');
    d.setAttribute('aria-hidden','false');
    document.body.classList.add('cs-drawer-open');
    if(!bestSellersLoaded && !bestSellersLoading){
      loadBestSellers();
    }
    refreshCart();
  }

  function closeDrawer(){
    var d = $('#cs-cart-drawer');
    var o = $('#cs-cart-drawer-overlay');
    if(!d || !o) return;
    d.classList.remove('open');
    o.classList.remove('open');
    d.setAttribute('aria-hidden','true');
    document.body.classList.remove('cs-drawer-open');
  }

  function refreshCart(){
    return origFetch('/cart.js',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(c){
        currentCart = c;
        renderCart(c);
        syncHeaderCartIcon();
        return c;
      })
      .catch(function(e){console.error('refreshCart error:',e);});
  }

  function renderCart(cart){
    var items = $('#cs-items');
    if(items){
      if(cart.item_count===0){
        items.innerHTML = '<div class="cs-empty">Tu carrito está vacío</div>';
      } else {
        var html = '';
        for(var i=0;i<cart.items.length;i++){
          var it = cart.items[i];
          html += '<div class="cs-row" data-key="'+it.key+'">';
          html += '<a href="'+it.url+'" class="cs-thumb">'+(it.image?'<img src="'+it.image+'" alt="" loading="lazy">':'')+'</a>';
          html += '<div class="cs-info">';
          html += '<div class="cs-row-top"><a href="'+it.url+'" class="cs-name">'+it.product_title+'</a><button class="cs-remove" data-key="'+it.key+'" type="button">×</button></div>';
          html += '<div class="cs-meta">'+(it.variant_title||'')+'</div>';
          html += '<div class="cs-bottom-row">';
          html += '<div class="cs-qty"><span class="cs-minus" data-key="'+it.key+'">−</span><span class="cs-qval">'+it.quantity+'</span><span class="cs-plus" data-key="'+it.key+'">+</span></div>';
          html += '<div class="cs-price">'+moneyFormat(it.final_line_price)+'</div>';
          html += '</div>';
          html += '</div></div>';
        }
        items.innerHTML = html;
      }
    }
    updateTotals(cart);
    updateTiersUI(cart);
  }

  function updateTotals(cart){
    var totEl = $('#cs-total');
    var subtotal = cart.original_total_price || cart.items_subtotal_price || cart.total_price;
    var totalFinal = cart.total_price;
    var descuento = cart.total_discount || (subtotal - totalFinal);

    if(totEl) totEl.textContent = moneyFormat(totalFinal);

    var dl = $('#cs-disc-line');
    if(dl){
      if(descuento > 0){
        dl.style.display = 'flex';
        var dv = $('#cs-disc-val');
        if(dv) dv.textContent = '-' + moneyFormat(descuento);
      } else {
        dl.style.display = 'none';
      }
    }
  }

  // === Lógica de la sección "Compra más, paga menos" (SOLO VISUAL) ===
  function updateTiersUI(cart){
    var pares = 0;
    if(cart && cart.items){
      for(var i=0;i<cart.items.length;i++){
        pares += cart.items[i].quantity;
      }
    }

    // Quitar activación de todas las cajas
    var boxes = document.querySelectorAll('.cs-tier-box');
    for(var j=0;j<boxes.length;j++){
      boxes[j].classList.remove('cs-tier-active');
    }

    // Activar la caja correspondiente
    var activeTier = null;
    if(pares >= 5) activeTier = 5;
    else if(pares === 4) activeTier = 4;
    else if(pares === 3) activeTier = 3;
    else if(pares === 2) activeTier = 2;

    if(activeTier){
      var activeBox = document.querySelector('.cs-tier-box[data-tier="'+activeTier+'"]');
      if(activeBox) activeBox.classList.add('cs-tier-active');
    }

    // Mensaje motivacional
    var msgEl = $('#cs-tier-msg');
    var msgText = $('#cs-tier-msg-text');
    var msgAmount = $('#cs-tier-msg-amount');
    if(!msgEl || !msgText || !msgAmount) return;

    msgEl.classList.remove('cs-tier-msg-max');

    if(pares === 0 || pares === 1){
      msgText.textContent = 'Agrega ' + (pares === 0 ? '2 pares' : '1 par más') + ' y ahorra';
      msgAmount.textContent = '$30.000';
    } else if(pares === 2){
      msgText.textContent = 'Agrega 1 par más y ahorra';
      msgAmount.textContent = '$50.000';
    } else if(pares === 3){
      msgText.textContent = 'Agrega 1 par más y ahorra';
      msgAmount.textContent = '$75.000';
    } else if(pares === 4){
      msgText.textContent = 'Agrega 1 par más y llévate';
      msgAmount.textContent = '+1 GRATIS';
    } else if(pares >= 5){
      msgText.textContent = '🎉 ¡Llevas el mejor descuento!';
      msgAmount.textContent = '+1 GRATIS';
      msgEl.classList.add('cs-tier-msg-max');
    }
  }

  function removeFromCart(key){
    var row = document.querySelector('.cs-row[data-key="'+key+'"]');
    if(row){
      row.style.transition = 'opacity .15s ease, transform .15s ease';
      row.style.opacity = '0';
      row.style.transform = 'translateX(20px)';
      setTimeout(function(){if(row.parentNode) row.parentNode.removeChild(row);}, 150);
    }
    origFetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({id: key, quantity: 0})
    }).then(function(r){
      if(r.ok) return r.json();
    }).then(function(cart){
      if(cart){
        currentCart = cart;
        renderCart(cart);
        syncHeaderCartIcon();
      }
    }).catch(function(e){ refreshCart(); });
  }

  function changeQuantity(key, qty){
    origFetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(function(r){
      if(r.ok) return r.json();
    }).then(function(cart){
      if(cart){
        currentCart = cart;
        renderCart(cart);
        syncHeaderCartIcon();
      }
    }).catch(function(e){ refreshCart(); });
  }

  function loadBestSellers(){
    bestSellersLoading = true;
    origFetch('/products.json?limit=' + TOTAL_PRODUCTS_LIMIT)
      .then(function(r){return r.ok ? r.json() : {products: []};})
      .then(function(d){
        bestSellersLoaded = true;
        bestSellersLoading = false;
        var grid = $('#cs-bs-grid');
        if(!grid) return;
        if(!d.products || d.products.length === 0){
          grid.innerHTML = '<div class="cs-loading">No hay productos</div>';
          return;
        }
        allProducts = d.products;
        productsShown = 0;
        renderInitialProducts();
      })
      .catch(function(e){
        bestSellersLoading = false;
        var grid = $('#cs-bs-grid');
        if(grid) grid.innerHTML = '<div class="cs-loading">Error al cargar</div>';
      });
  }

  function renderInitialProducts(){
    var grid = $('#cs-bs-grid');
    if(!grid) return;
    grid.innerHTML = '';
    appendMoreProducts(INITIAL_PRODUCTS);
    updateLoadMoreButton();
  }

  function appendMoreProducts(count){
    var grid = $('#cs-bs-grid');
    if(!grid) return;
    var end = Math.min(productsShown + count, allProducts.length);
    var html = '';
    for(var idx=productsShown;idx<end;idx++){
      var p = allProducts[idx];
      if(!p.variants || p.variants.length===0) continue;
      var v = p.variants[0];
      var img = (p.images && p.images[0]) ? p.images[0].src : '';
      var price = parseFloat(v.price);
      var compare = v.compare_at_price ? parseFloat(v.compare_at_price) : null;
      var oldHtml = (compare && compare>price) ? '<span class="old">'+moneyFormat(compare*100)+'</span>' : '';
      var productUrl = '/products/' + p.handle;
      html += '<div class="cs-pc" data-handle="'+p.handle+'" data-url="'+productUrl+'">';
      html += '<div class="cs-pc-rk">#'+(idx+1)+'</div>';
      html += '<a href="'+productUrl+'" class="cs-pc-img-link"><div class="cs-pc-img">'+(img?'<img src="'+img+'" alt="'+p.title+'" loading="lazy">':'')+'</div></a>';
      html += '<a href="'+productUrl+'" class="cs-pc-nm-link"><div class="cs-pc-nm">'+p.title+'</div></a>';
      html += '<div class="cs-pc-pr">'+oldHtml+moneyFormat(price*100)+'</div>';
      html += '<div class="cs-pc-size"><span class="lbl">Talla</span><span class="arr">▼</span></div>';
      html += '<div class="cs-pc-sizes">';
      html += renderSizesForProduct(p.variants);
      html += '</div>';
      html += '<button class="cs-pc-add" type="button" disabled>AGREGAR</button>';
      html += '</div>';
    }
    grid.insertAdjacentHTML('beforeend', html);
    productsShown = end;
    updateLoadMoreButton();
  }

  function updateLoadMoreButton(){
    var btnWrap = $('#cs-load-more-wrap');
    if(!btnWrap) return;
    if(productsShown < allProducts.length){
      var remaining = allProducts.length - productsShown;
      var nextBatch = Math.min(PRODUCTS_PER_LOAD, remaining);
      btnWrap.style.display = 'block';
      btnWrap.innerHTML = '<button id="cs-load-more" type="button" class="cs-load-more-btn">VER MÁS PRODUCTOS ('+nextBatch+')</button>';
    } else {
      btnWrap.style.display = 'none';
      btnWrap.innerHTML = '';
    }
  }

  function handleAddBtnClick(btn){
    var vid = btn.dataset.vid;
    if(!vid || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.classList.add('ok');
    btn.textContent = '✓ AGREGADO';
    setTimeout(function(){
      btn.classList.remove('ok');
      btn.textContent = original;
      btn.disabled = false;
    }, 1000);
    origFetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:vid, quantity:1})
    }).then(function(r){
      if(r.ok) return r.json();
    }).then(function(){
      refreshCart();
    }).catch(function(){});
  }

  document.addEventListener('click',function(e){
    var target = e.target;

    if(target.classList && target.classList.contains('cs-remove')){
      e.preventDefault(); e.stopPropagation();
      var key = target.dataset.key;
      if(key) removeFromCart(key);
      return;
    }

    if(target.classList && target.classList.contains('cs-minus')){
      e.preventDefault(); e.stopPropagation();
      var rowMinus = target.closest('.cs-row');
      if(!rowMinus) return;
      var keyMinus = target.dataset.key;
      var curMinus = parseInt(rowMinus.querySelector('.cs-qval').textContent) || 0;
      var newQtyMinus = Math.max(0, curMinus - 1);
      if(newQtyMinus === 0){ removeFromCart(keyMinus); } else { changeQuantity(keyMinus, newQtyMinus); }
      return;
    }

    if(target.classList && target.classList.contains('cs-plus')){
      e.preventDefault(); e.stopPropagation();
      var rowPlus = target.closest('.cs-row');
      if(!rowPlus) return;
      var keyPlus = target.dataset.key;
      var curPlus = parseInt(rowPlus.querySelector('.cs-qval').textContent) || 0;
      changeQuantity(keyPlus, curPlus + 1);
      return;
    }

    var sizeToggle = target.closest('.cs-pc-size');
    if(sizeToggle){
      var sizesBox = sizeToggle.parentElement.querySelector('.cs-pc-sizes');
      if(sizesBox) sizesBox.classList.toggle('show');
      return;
    }

    if(target.classList && target.classList.contains('cs-pc-sb')){
      if(target.classList.contains('out')) return;
      var card = target.closest('.cs-pc');
      if(!card) return;
      var sizeBtn = card.querySelector('.cs-pc-size');
      var sizesBox2 = card.querySelector('.cs-pc-sizes');
      var addBtn = card.querySelector('.cs-pc-add');
      var label = target.dataset.label || target.textContent;
      sizeBtn.querySelector('.lbl').textContent = label;
      sizeBtn.classList.add('active');
      sizesBox2.classList.remove('show');
      addBtn.disabled = false;
      addBtn.dataset.vid = target.dataset.vid;
      return;
    }

    var addBtnClick = target.closest('.cs-pc-add');
    if(addBtnClick && !addBtnClick.disabled){
      e.preventDefault(); e.stopPropagation();
      handleAddBtnClick(addBtnClick);
      return;
    }

    if(target.id === 'cs-load-more'){
      appendMoreProducts(PRODUCTS_PER_LOAD);
      return;
    }
  }, true);

  document.addEventListener('submit',function(e){
    if(e.target.closest('.cs-drawer')) return;
    var form = e.target;
    if(!form.matches || !form.matches('form[action="/cart/add"], form[action$="/cart/add"]')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    openDrawer();
    if(currentCart){
      currentCart.item_count = (currentCart.item_count || 0) + 1;
      updateHeaderBubbleLocal(currentCart.item_count);
    }
    var fd = new FormData(form);
    origFetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(){return refreshCart();})
      .catch(function(err){refreshCart();});
  }, true);

  function initOpenTriggers(){
    document.addEventListener('click',function(e){
      if(e.target.closest('.cs-drawer')) return;
      var t = e.target.closest('a[href="/cart"], a[href$="/cart"], .cart-icon-bubble, [data-cart-toggle], .header__icon--cart, #cart-icon-bubble');
      if(t){
        e.preventDefault(); e.stopPropagation();
        openDrawer();
      }
    });
  }

  function init(){
    var closeBtn = $('#cs-close');
    var overlay = $('#cs-cart-drawer-overlay');
    var checkout = $('#cs-checkout');
    if(closeBtn) closeBtn.addEventListener('click',closeDrawer);
    if(overlay) overlay.addEventListener('click',closeDrawer);
    if(checkout) checkout.addEventListener('click',function(){window.location.href='/checkout';});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
    initOpenTriggers();
    refreshCart();
    setTimeout(function(){
      if(!bestSellersLoaded && !bestSellersLoading){
        loadBestSellers();
      }
    }, 2000);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();